export const showData = (data) => {
    if (data === '' || data === null || data === undefined) return '-';

    return data;
};
